export const baseColors = {
  red: 'rgba(238, 17, 131, 1)',
  yellow: 'rgba(255, 255, 0, 1)',
  black: 'rgba(0, 0, 0, 0.8)',
  golden: 'rgba(245, 229, 27, 0.5)',
  gray: 'rgba(246, 243, 245, 0.5)',
};

// Themes taken from https://colorhunt.co/palettes

export const FiestaThemes = {
  Default: ['#F4BFBF', '#FFD9C0', '#FAF0D7', '#8CC0DE'],
  Dark: ['#362222', '#171010', '#423F3E', '#2B2B2B'],
  Wedding: ['#F9CEEE', '#F9F3EE', '#CCF3EE', '#97C4B8'],
  Halloween: ['#EEB76B', '#E2703A', '#9C3D54', '#310B0B'],
  Neon: ['#7C83FD', '#96BAFF', '#7DEDFF', '#88FFF7'],
  Christmas: ['#C9182B', '#F23A3A', '#E3F3AC', '#44C662'],
};
